import { GET_USER, REMOVE_USER } from "./types";
import firebase from "firebase/app";
import "firebase/firestore";

const devPath = "consola/development/loyaltyRewardsPerLevel/rewards";

export const getUser = (email) => async (dispatch, getState) => {
	const {
		databasesRef: { usersDB },
	} = getState().auth;

	try {
		const userDoc = await usersDB.where("mail", "==", email).get();
		let user;

		for (const doc of userDoc.docs) {
			user = { ...doc.data(), id: doc.id };
		}

		if (!user) {
			alert("No se encontro usuario");
			return;
		}
		dispatch({ type: GET_USER, payload: user });
	} catch (error) {
		alert("Ocurrio un error");
		console.log(error);
	}
};

export const updateUserLevel = ({ id, level, loyaltyPoints }, callback) => async (dispatch, getState) => {
	const rewardsPath = "userLoyaltyRewards";
	const documentName = "rewards";
	const rewardsCollectionPath = "loyaltyRewardsPerLevel";
	const {
		databasesRef: { consoleDB, firestore },
	} = await getState().auth;

	if (!consoleDB) return;

	const {
		databasesRef: { usersDB },
	} = getState().auth;

	const levels = {
		classic: 1,
		silver: 2,
		gold: 3,
		platinum: 4,
	};

	try {
		if (level === "classic") {
			await usersDB.doc(id).set({ level: levels[level] }, { merge: true });
		} else {
			const batch = firestore.batch();
			batch.set(
				usersDB.doc(id),
				{
					level: levels[level],
					loyaltyTimestamp: new Date(),
					loyaltyPoints: Number(loyaltyPoints),
				},
				{ merge: true }
			);
			const rewardsCollection = await firestore.collectionGroup(rewardsCollectionPath).get();
			const rewardsRef = usersDB.doc(id).collection(rewardsPath).doc(documentName);

			let rewards = [];

			for (const rewardDoc of rewardsCollection.docs) {
				if (rewardDoc.ref.path === devPath) continue;
				const rewardData = rewardDoc.data();
				const levelRewards = rewardData[level];
				if (levelRewards) rewards = [...rewards, ...levelRewards];
			}

			const rewardsDoc = await rewardsRef.get();
			let updatedRewards;
			if (rewardsDoc.exists) {
				const { rewards: currentRewards } = rewardsDoc.data();

				let rewardsObj = {};

				currentRewards.forEach((reward) => {
					const id = reward.item._id;
					rewardsObj = { ...rewardsObj, [id]: reward };
				});

				rewards.forEach((reward) => {
					const id = reward.item._id;
					if (rewardsObj[id]) {
						rewardsObj = {
							...rewardsObj,
							[id]: { ...reward, amount: reward.amount + rewardsObj[id].amount },
						};
					} else {
						rewardsObj = { ...rewardsObj, [id]: reward };
					}
				});

				updatedRewards = Object.values(rewardsObj);
			} else {
				updatedRewards = rewards;
			}
			if (updatedRewards.length > 0) {
				batch.set(
					usersDB.doc(id).collection(rewardsPath).doc(documentName),
					{
						rewards: updatedRewards,
					},
					{ merge: true }
				);
			}
			batch.commit();
		}
		callback && callback();

		dispatch({ type: REMOVE_USER });
	} catch (error) {
		alert("No se pudo actualizar al usuario");
		console.log(error);
	}
};

export const removeUserFromState = () => async (dispatch) => {
	try {
		dispatch({ type: REMOVE_USER });
	} catch (error) {
		alert("No se pudo actualizar al usuario");
		console.log(error);
	}
};
